module.exports = __webpack_public_path__ + "img/api-equarity.4ea35464.png";